// GTM-only analytics wrapper for No-Belly Bier.
//
// - Google Tag Manager (GTM-56VGNV3C) is loaded once from public/index.html,
//   only on production hostnames (nobelly.in / www.nobelly.in). GA4
//   (G-SF97477760) is configured inside GTM as the Google Tag; there is no
//   separate gtag.js install on the website.
// - On preview / localhost, dataLayer.push() still runs so QA can inspect
//   events in the browser console, but GTM is never loaded and therefore no
//   Analytics request leaves the environment.
// - Callers MUST NOT pass names, emails, phone numbers, messages or any
//   other personal information — only the parameter shapes documented below.

const PROD_HOSTS = ['nobelly.in', 'www.nobelly.in'];

function isProdHost() {
  if (typeof window === 'undefined') return false;
  return PROD_HOSTS.includes(window.location.hostname);
}

function safePush(payload) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  try { window.dataLayer.push(payload); } catch (_) { /* ignore */ }
  if (!isProdHost()) {
    // eslint-disable-next-line no-console
    console.info('[analytics]', payload);
  }
}

/**
 * Push a custom event to the dataLayer.
 *
 *  Store events accept only:  { city, outlet_name, search_term, button_location }
 *  Form events accept only:   { form_name, page_path, submission_status }
 *  Outbound clicks accept:    { button_location }
 */
export function pushEvent(event, params = {}) {
  if (!event) return;
  safePush({ event, ...params });
}

// Backwards-compat alias used by older imports.
export const track = pushEvent;

/**
 * Push a virtual page-view for a genuine client-side route change.
 * Do NOT call this on the initial page load — GTM's Google Tag fires the
 * first page_view automatically.
 */
export function pushPageView({ path, title } = {}) {
  if (typeof window === 'undefined') return;
  const loc = window.location;
  safePush({
    event: 'virtual_page_view',
    page_path: path || (loc.pathname + loc.search),
    page_location: loc.href,
    page_title: title || document.title,
  });
}

/**
 * Update Google Consent Mode after the visitor makes a choice in the
 * cookie banner. Age verification is separate and does NOT grant consent.
 */
export function updateAnalyticsConsent(granted) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    try {
      window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
      });
    } catch (_) { /* ignore */ }
  }
  safePush({
    event: 'cookie_consent_updated',
    consent_status: granted ? 'accepted' : 'rejected',
  });
}
